import classNames from 'classnames';
import { SVGProps } from 'react';
import { SVGPropsIcon } from 'src/types';

type SpinProps = SVGPropsIcon & {
  spinOnCenter?: boolean;
};

export const Spin = (props: SpinProps) => {
  return (
    <div
      {...props}
      className={classNames(
        'flex items-center justify-center self-center',
        props.spinOnCenter ? 'absolute' : 'mr-[12px]'
      )}>
      <svg
        role="status"
        className={classNames(
          'inline w-[20px] h-[20px] text-background-6 animate-spin',
          props.className ? `${props.className}` : ''
        )}
        viewBox="0 0 100 101"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
          fill="#8188af"></path>
        <path
          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
          fill="currentColor"></path>
      </svg>
    </div>
  );
};

export const Info = (props: SVGPropsIcon) => {
  return (
    <svg
      {...props}
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 4.34009C7.94365 4.34009 4.25 8.03374 4.25 12.5901C4.25 17.1464 7.94365 20.8401 12.5 20.8401C17.0563 20.8401 20.75 17.1464 20.75 12.5901C20.75 8.03374 17.0563 4.34009 12.5 4.34009ZM2.75 12.5901C2.75 7.20531 7.11522 2.84009 12.5 2.84009C17.8848 2.84009 22.25 7.20531 22.25 12.5901C22.25 17.9749 17.8848 22.3401 12.5 22.3401C7.11522 22.3401 2.75 17.9749 2.75 12.5901Z"
        fill={props.fill ? props.fill : 'var(--wdap_amount_text)'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 11.8401C11 11.4259 11.3358 11.0901 11.75 11.0901H12.5C12.9142 11.0901 13.25 11.4259 13.25 11.8401V16.3401C13.6642 16.3401 14 16.6759 14 17.0901C14 17.5043 13.6642 17.8401 13.25 17.8401H12.5C12.0858 17.8401 11.75 17.5043 11.75 17.0901V12.5901C11.3358 12.5901 11 12.2543 11 11.8401Z"
        fill={props.fill ? props.fill : 'var(--wdap_amount_text)'}
      />
      <path
        d="M12.3125 9.59009C12.9338 9.59009 13.4375 9.08641 13.4375 8.46509C13.4375 7.84377 12.9338 7.34009 12.3125 7.34009C11.6912 7.34009 11.1875 7.84377 11.1875 8.46509C11.1875 9.08641 11.6912 9.59009 12.3125 9.59009Z"
        fill={props.fill ? props.fill : 'var(--wdap_amount_text)'}
      />
    </svg>
  );
};

export const AutocompleteIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      {...props}
      width="13"
      height="7"
      viewBox="0 0 13 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.3634 0.331331L6.50323 4.23109L2.60347 0.370946C2.51042 0.278838 2.40013 0.205961 2.27891 0.156474C2.15769 0.106987 2.02792 0.0818597 1.89699 0.0825281C1.76606 0.0831966 1.63654 0.109647 1.51584 0.160369C1.39513 0.211091 1.2856 0.285091 1.19349 0.378144C1.10138 0.471197 1.0285 0.581482 0.979015 0.7027C0.929528 0.823918 0.904401 0.953697 0.90507 1.08463C0.905738 1.21555 0.932188 1.34507 0.98291 1.46578C1.03363 1.58648 1.10763 1.69602 1.20069 1.78813L5.81406 6.35463C5.90704 6.44686 6.01731 6.51985 6.13853 6.56941C6.25976 6.61898 6.38957 6.64414 6.52054 6.64347C6.65151 6.64281 6.78106 6.61631 6.90177 6.56552C7.02249 6.51472 7.132 6.44061 7.22404 6.34744L11.7905 1.73406C12.1786 1.34208 12.1753 0.712085 11.7833 0.324082C11.3914 -0.0539226 10.7514 -0.060655 10.3634 0.331331Z"
        fill="#9D9D9D"
      />
    </svg>
  );
};
